module.exports = __webpack_public_path__ + "static/img/other-donghuati.edd3c7bb.png";